// Переклади для угорської та англійської мов
export const translations = {
  hu: {
    // Navigation
    nav: {
      home: 'Főoldal',
      hookahs: 'Vízipipák',
      accessories: 'Kiegészítők',
      sets: 'Teljes készletek',
      cart: 'Kosár',
      contact: 'Kapcsolat',
      sale: 'Akciók',
    },
    // Hero section
    hero: {
      title: 'Prémium Vízipipák',
      subtitle: 'Fedezze fel a legjobb vízipipákat és kiegészítőket Magyarországon',
      cta: 'Termékek megtekintése',
      instagram: 'Kövess Instagramon',
    },
    // Categories
    categories: {
      title: 'Kategóriák',
      hookahs: 'Vízipipák',
      hookahsDesc: 'Prémium minőségű vízipipák a legjobb márkáktól',
      accessories: 'Kiegészítők',
      accessoriesDesc: 'Minden, ami a tökéletes élményhez kell',
      sets: 'Teljes készletek',
      setsDesc: 'Készen áll használatra - minden benne van',
    },
    // Products
    products: {
      featured: 'Kiemelt termékek',
      bestsellers: 'Legnépszerűbb',
      new: 'Újdonságok',
      addToCart: 'Kosárba',
      viewDetails: 'Részletek',
      inStock: 'Raktáron',
      outOfStock: 'Elfogyott',
      price: 'Ár',
      height: 'Magasság',
      brand: 'Márka',
      description: 'Leírás',
      items: 'termék',
    },
    // Cart
    cart: {
      title: 'Kosár',
      empty: 'A kosár üres',
      total: 'Összesen',
      checkout: 'Megrendelés',
      remove: 'Törlés',
      continueShopping: 'Vásárlás folytatása',
      quantity: 'Mennyiség',
    },
    // Checkout
    checkout: {
      title: 'Megrendelés',
      name: 'Teljes név',
      email: 'E-mail cím',
      phone: 'Telefonszám',
      delivery: 'Szállítási mód',
      pickup: 'Személyes átvétel - Debrecen',
      domestic: 'Házhozszállítás / csomagautomatába',
      international: 'Nemzetközi szállítás',
      address: 'Szállítási cím',
      city: 'Város',
      zip: 'Irányítószám',
      country: 'Ország',
      notes: 'Megjegyzés',
      submit: 'Megrendelés elküldése',
      success: 'Köszönjük a megrendelést! Hamarosan felvesszük Önnel a kapcsolatot.',
      internationalNote: 'Nemzetközi rendelés esetén felvesszük Önnel a kapcsolatot a szállítás egyeztetéséhez.',
      promoCode: 'Promókód',
      promoCodePlaceholder: 'Adja meg a promókódot',
      promoCodeApply: 'Alkalmaz',
      promoCodeApplied: 'Promókód alkalmazva',
      promoCodeInvalid: 'Érvénytelen promókód',
      promoCodeExpired: 'Lejárt promókód',
      discount: 'Kedvezmény',
      subtotal: 'Részösszeg',
      paymentMethod: 'Fizetési mód',
      cashOnDelivery: 'Fizetés átvételkor',
      prepayment: 'Előre fizetés',
      prepaymentNote: 'Előre fizetés esetén felvesszük Önnel a kapcsolatot a fizetés lebonyolításához.',
    },
    // Footer
    footer: {
      delivery: 'Szállítás',
      deliveryDesc: '1-3 munkanap Magyarországon',
      support: 'Ügyfélszolgálat',
      supportDesc: 'Kérdése van? Írjon nekünk!',
      quality: 'Minőség',
      qualityDesc: 'Csak eredeti termékek',
      rights: 'Minden jog fenntartva',
      followUs: 'Kövessen minket',
    },
    // Filters
    filters: {
      all: 'Összes',
      sortBy: 'Rendezés',
      priceAsc: 'Ár szerint növekvő',
      priceDesc: 'Ár szerint csökkenő',
      nameAsc: 'Név szerint (A-Z)',
      nameDesc: 'Név szerint (Z-A)',
      brand: 'Márka',
    },
    // Common
    common: {
      currency: 'HUF',
      search: 'Keresés...',
      loading: 'Betöltés...',
      error: 'Hiba történt',
      back: 'Vissza',
      close: 'Bezárás',
      noResults: 'Nincs találat',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      hookahs: 'Hookahs',
      accessories: 'Accessories',
      sets: 'Complete Sets',
      cart: 'Cart',
      contact: 'Contact',
      sale: 'Sale',
    },
    // Hero section
    hero: {
      title: 'Premium Hookahs',
      subtitle: 'Discover the finest hookahs and accessories in Hungary',
      cta: 'View Products',
      instagram: 'Follow us on Instagram',
    },
    // Categories
    categories: {
      title: 'Categories',
      hookahs: 'Hookahs',
      hookahsDesc: 'Premium quality hookahs from the best brands',
      accessories: 'Accessories',
      accessoriesDesc: 'Everything you need for the perfect experience',
      sets: 'Complete Sets',
      setsDesc: 'Ready to use - everything included',
    },
    // Products
    products: {
      featured: 'Featured Products',
      bestsellers: 'Bestsellers',
      new: 'New Arrivals',
      addToCart: 'Add to Cart',
      viewDetails: 'Details',
      inStock: 'In Stock',
      outOfStock: 'Out of Stock',
      price: 'Price',
      height: 'Height',
      brand: 'Brand',
      description: 'Description',
      items: 'items',
    },
    // Cart
    cart: {
      title: 'Shopping Cart',
      empty: 'Your cart is empty',
      total: 'Total',
      checkout: 'Checkout',
      remove: 'Remove',
      continueShopping: 'Continue Shopping',
      quantity: 'Quantity',
    },
    // Checkout
    checkout: {
      title: 'Checkout',
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      delivery: 'Delivery Method',
      pickup: 'Personal Pickup - Debrecen',
      domestic: 'Home Delivery / Parcel Locker',
      international: 'International Shipping',
      address: 'Shipping Address',
      city: 'City',
      zip: 'ZIP Code',
      country: 'Country',
      notes: 'Order Notes',
      submit: 'Place Order',
      success: 'Thank you for your order! We will contact you soon.',
      internationalNote: 'For international orders, we will contact you to arrange shipping details.',
      promoCode: 'Promo Code',
      promoCodePlaceholder: 'Enter promo code',
      promoCodeApply: 'Apply',
      promoCodeApplied: 'Promo code applied',
      promoCodeInvalid: 'Invalid promo code',
      promoCodeExpired: 'Expired promo code',
      discount: 'Discount',
      subtotal: 'Subtotal',
      paymentMethod: 'Payment Method',
      cashOnDelivery: 'Cash on Delivery',
      prepayment: 'Prepayment',
      prepaymentNote: 'For prepayment, we will contact you to arrange the payment.',
    },
    // Footer
    footer: {
      delivery: 'Delivery',
      deliveryDesc: '1-3 business days in Hungary',
      support: 'Customer Support',
      supportDesc: 'Questions? Contact us!',
      quality: 'Quality',
      qualityDesc: 'Only original products',
      rights: 'All rights reserved',
      followUs: 'Follow Us',
    },
    // Filters
    filters: {
      all: 'All',
      sortBy: 'Sort by',
      priceAsc: 'Price: Low to High',
      priceDesc: 'Price: High to Low',
      nameAsc: 'Name (A-Z)',
      nameDesc: 'Name (Z-A)',
      brand: 'Brand',
    },
    // Common
    common: {
      currency: 'HUF',
      search: 'Search...',
      loading: 'Loading...',
      error: 'An error occurred',
      back: 'Back',
      close: 'Close',
      noResults: 'No results found',
    },
  },
};
